import { motion } from 'framer-motion'

// Components
import Name from 'components/interestform/formcomponents/name'
import Email from 'components/interestform/formcomponents/email'

// Utils
import { pageVariants } from 'components/interestform/utils'
import commonStyles from 'components/interestform/slides/common.css'
import styles from './contactinformation.css'

const ContactInformation = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={styles.heading}>
        Contact Information
        <span className={styles.requiredStar}>*</span>
      </h1>
      <div className={styles.subheading}>Finally, we need to know about you! We need your real name, and a way to contact you! </div>
      <div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>What is your name?</div>
          <div className={styles.questionDetails}>Tell us your real name</div>
          <Name onReview={false} />
        </div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>What email can we contact you on?</div>
          <div className={styles.questionDetails}>Tell us where is best to get in touch with you</div>
          <Email onReview={false} emailKey="personal" />
        </div>
      </div>
    </motion.div>
  )
}

export default ContactInformation
